import * as types from './actionTypes';

export function setUserSuccess(user) {
    return {type: types.SET_USER_SUCCESS, user};
}

export function setUser(data) {
    // make async call to api, handle promise, dispatch action when promise is resolved
    return function(dispatch) {
        return dispatch(setUserSuccess(data));
    };
}
